import { render, staticRenderFns } from "./MachineDetails.vue?vue&type=template&id=2d3fa9d4&"
import script from "./MachineDetails.vue?vue&type=script&lang=ts&"
export * from "./MachineDetails.vue?vue&type=script&lang=ts&"
import style0 from "./MachineDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports